import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { MdPending } from "react-icons/md";

const listItems = [
  { text: "1000 readers for my newsletter by December 2026", done: false },
  { text: "Publish high-impact research in a top journal (work in progress)", done: false },
  { text: "Splits and cartwheel", done: false },
  { text: "Speak at TED", done: false },
  { text: "Write and produce my own single", done: false },
  { text: "DJ for a night", done: false },
  { text: "Hit the high notes in Million Dreams using my chest voice", done: false },
  { text: "Perform standup comedy in an open mic", done: true },
  { text: "Karaoke nights", done: true },
  { text: "Perform 'When I Look at You' live", done: true },
  { text: "Scuba Diving", done: false },
  { text: "Sky Diving", done: false },
  { text: "Visit a goth club", done: false },
  { text: "Attend La Tomatina", done: false },
  // { text: "Attend a pop concert May 2026", done: false },
  { text: "Attend the next Taylor Swift concert", done: false }
];

function List100() {
  return (
    <Container fluid className="about-section">
      <Row style={{ justifyContent: "center", padding: "100px" }}>
        <Col md={8} className="quote-card-view list100-card">
          <div className="list100-intro">
            <p>Things on my two-year goals & experiences list (constantly evolving and unordered).</p>
            <p>Some well-thought and some totally random. Inspired from Chip Huyen's list.</p>
          </div>
          <ul className="list100-grid">
            {listItems.map((item) => (
              <li key={item.text} className={item.done ? "done" : "pending"}>
                <span className="list100-icon">
                  {item.done ? <FaCheckCircle /> : <MdPending />}
                </span>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default List100;
